module.exports = __webpack_public_path__ + "img/cuadro.36c7435e.svg";